import React, { useState, useContext, useEffect } from "react";
import styled from "@emotion/styled";
import Avatar from "@mui/material/Avatar";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
//import colors from "./UiComponent";
import { KeyboardArrowDownOutlined } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import {
  alpha,
  Badge,
  Box,
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Menu,
  MenuItem,
  Popover,
} from "@mui/material";
import Fade from "@mui/material/Fade";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { ColorModeContext } from "../App";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import LogoutIcon from "@mui/icons-material/Logout";
import Confirm from "./Confirm";
import { useNavigate } from "react-router-dom";
import ProfileContext from "../context/ProfileContext";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import StaffContext from "../context/StaffContext";
import useAuth from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 20px;
  padding: 12px 24px;
  width: 100%;
  background-color: ${(props) => props.palette.background.default};
  color: ${(props) => props.palette.primary.main};
  font-family: "Poppins", sans-serif;
  position: sticky;
  top: 0;
  left: 0;
  ${"" /*z-index: 3;*/}
`;

const ImgContainer = styled.div`
  padding: 5px 10px;
  background-color: ${(props) => props.palette.primary.finalLight};
  display: flex;
  border-radius: 30px;
  align-items: center;
  width: fit-content;
  height: fit-content;
  gap: 15px;
  cursor: pointer;
  color: ${(props) => props.palette.primary.lighter};
`;
const Title = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "15px",
  color: theme.palette.third.main,
  fontWeight: "400",
  fontSize: "15px",
  position: "sticky",
  top: "0",
  background: theme.palette.background.default,
  borderBottom: `0.5px solid ${theme.palette.third.light}`,
}));
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(5),
    minWidth: 180,
    background: theme.palette.background.default,
    boxShadow: `0px 0px 7px ${theme.palette.background.paper}`,
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));
const NotificationMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 8,
    marginTop: theme.spacing(4),
    minWidth: 450,
    background: theme.palette.background.default,
    boxShadow: `0px 0px 7px ${theme.palette.background.paper}`,
    border: `1px solid ${theme.palette.third.main}`,
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));
const Notification = styled(Box)(({ theme }) => ({
  cursor: "pointer",
}));

function TopBar() {
  // const [notifList,setNotifList]=useState([
  //   {
  //     id:'1',
  //     detail:"Overload Request has been sent",
  //     seen:false,
  //     type:'/staff_overload'
  //   },
  //   {
  //     id:'2',
  //     detail:"Research has been Accepted",
  //     seen:false,
  //     type:'/researches'
  //   },
  //   {
  //     id:'3',
  //     detail:"Course Offerings is now open ",
  //     seen:false,
  //     type:'/offering'
  //   },
  //   {
  //     id:'4',
  //     detail:"Overload Request has been sent",
  //     seen:false,
  //     type:'/staff_overload'
  //   },
  //   {
  //     id:'5',
  //     detail:"Research has been Accepted",
  //     seen:false,
  //     type:'/researches'
  //   },
  //   {
  //     id:'6',
  //     detail:"Course Offerings is now open ",
  //     seen:false,
  //     type:'/offering'
  //   },
  //     {
  //     id:'7',
  //     detail:"Overload Request has been sent",
  //     seen:false,
  //     type:'/staff_overload'
  //   },
  //   {
  //     id:'8',
  //     detail:"Research has been Accepted",
  //     seen:false,
  //     type:'/researches'
  //   },
  //   {
    //     id:'9',
    //     detail:"Course Offerings is now open ",
    //     seen:false,
    //     type:'/offering'
    //   },
    //   {
      //     id:'10',
      //     detail:"Overload Request has been sent",
  //     seen:false,
  //     type:'/staff_overload'
  //   },
  //   {
    //     id:'11',
  //     detail:"Research has been Accepted",
  //     seen:false,
  //     type:'/researches'
  //   },
  //   {
  //     id:'12',
  //     detail:"Course Offerings is now open ",
  //     seen:false,
  //     type:'/offering'
  //   },
  // ])
  
  const [refresh, setRefresh] = useState(false);
  const [ProfilePic,setProfilePic]=useState()
  // setInterval(()=>setRefresh((prev)=>!prev),5000)
  const [notifList, setNotifList] = useState([]);
  const { user,changed } = useAuth();
  const api = useAxiosPrivate();
  
  const { state } = useContext(ProfileContext);
  const { host,pic, first_name, middle_name } = state;
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await api.get(`notification/view/`, {
          signal: controller.signal,
        });
        // console.log(pic,first_name)
        isMounted && setNotifList(response.data);
      } catch (err) {
        console.error(err);
      }
    };
    getData();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [changed, refresh,state]);
  const hasOffice = user?.roles ? Math.max(...user?.roles) === 115 : false;
  const [openNotf, setOpenNotf] = useState(false);
  const navigate = useNavigate();
  const seeNotf = async (id) => {
    const response = await api.patch("notification/seen/", { id: id });
    setNotifList((prevNotfList) =>
      prevNotfList.map((list) => {
        if (list.id === id) {
          office.office && setOffice({ type: "office_staff" });
          navigate(list.type, {
            state: { id: list.value, message: list.details },
          });
        }
        return list.id === id ? { ...list, seen: true } : list;
      })
    );
    setOpenNotf(false);
  };
  const clearNotf = () => {
    setNotifList((prevNotfList) =>
      prevNotfList.map((list) => {
        return { ...list, seen: true };
      })
    );
    setOpenNotf(false);
  };
  const [log, setLog] = useState(false);
  const { mode, colorMode } = useContext(ColorModeContext);
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { state: office, dispatch: setOffice } = useContext(StaffContext);
  return (
    <Header palette={theme.palette}>
      {notifList.length > 0 && (
        <Notification onClick={() => setOpenNotf(!openNotf)}>
          <Badge
            badgeContent={notifList.length}
            color="secondary"
            sx={{
              "& .MuiBadge-badge": {
                fontSize: 9,
                height: 20,
                minWidth: 20,
                marginRight: "3px",
                marginTop: "3px",
              },
            }}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <NotificationsOutlinedIcon />
          </Badge>
          <NotificationMenu
            MenuListProps={{
              "aria-labelledby": "fade-button",
            }}
            PaperProps={{
              style: {
                maxHeight: "60%",
                width: "20ch",
              },
            }}
            open={openNotf}
            onClose={() => setOpenNotf(!openNotf)}
            TransitionComponent={Fade}
          >
            {}
            <Title sx={{ zIndex: 5 }}>
              Notification
              <Button
                variant="contained"
                size="small"
                onClick={clearNotf}
                sx={{
                  bgcolor: "secondary.main",
                  fontWeight: 400,
                  color: "#fff",
                  "&:hover": {
                    bgcolor: "secondary.hover",
                  },
                }}
              >
                Clear
              </Button>
            </Title>
            {notifList.map((list) => {
              return (
                list.seen === false && (
                  <Box key={list.id}>
                    <MenuItem onClick={() => seeNotf(list.id)}>
                      {list.details}
                    </MenuItem>
                    <Divider />
                  </Box>
                )
              );
            })}
          </NotificationMenu>
        </Notification>
      )}

      <ImgContainer
        palette={theme.palette}
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Avatar
          src={host+pic+`?token=${user?.accessToken}`}
          alt={`${first_name} ${middle_name}`}
          sx={{ width: 32, height: 32 }}
        />
        <KeyboardArrowDownOutlined />
      </ImgContainer>
      <StyledMenu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            navigate("/setting");
            office.office && setOffice({ type: "office_staff" });
          }}
        >
          <AccountCircleOutlinedIcon />
          Profile
        </MenuItem>
        <MenuItem onClick={colorMode}>
          {mode === "light" ? <Brightness4Icon /> : <Brightness7Icon />}
          {mode === "light" ? "Dark Mode" : "Light Mode"}
        </MenuItem>
        {!hasOffice && <Divider />}
        {!hasOffice && (
          <MenuItem
            onClick={() => {
              handleClose();
              setOffice({ type: "office_staff" });
              navigate(office.office ? "/" : "/dashboard");
            }}
          >
            {office.office ? (
              <MenuBookOutlinedIcon />
            ) : (
              <BusinessCenterOutlinedIcon />
            )}
            {office.office ? "Staff Account" : "Office Account"}
          </MenuItem>
        )}
        <Divider />

        <MenuItem
          onClick={() => setLog(true)}
          sx={{
            display: "flex",
            gap: "6px",
          }}
        >
          Logout
          <LogoutIcon />
        </MenuItem>
      </StyledMenu>
      <Confirm
        log={log}
        setLog={setLog}
        message="Are you sure you wish to log out"
      />
    </Header>
  );
}

export default TopBar;
